export * from './main/main.component';
export * from './footer/footer.component';
export * from './profiles/page-ribbon.component';
export * from './error/error.component';
export * from './footer/mention-legale/mention-legale.component';
export * from './footer/condition-generale/condition-generale.component';
export * from './navbar/navbar.component';
export * from './profiles/profile.service';
export * from './layout-routing.module';



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/index.ts